module.exports = __webpack_public_path__ + "img/top_13.326fa644.png";